<template>
  <div class="app" :key="componentKey">
    <AppHeader fixed>
      
        <SidebarToggler  :defaultOpen=true   class="d-lg-none" display="md" mobile />
      <!--    <span class="head_menu_portal">
          {{this.usertype}}<br/>
         <span style="font-weight:normal">Portal</span>
         </span> -->
        
        <!-- <span style="padding-left:5px;">
         <h3><svg width="26" height="24" viewBox="0 0 26 24" fill="none" class="sidebar-custom__img" alt="Collections"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C1 4.13401 4.13401 1 8 1H18C21.866 1 25 4.13401 25 8V14H20V19H6V14H1V8Z" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8 1C8 3.76142 10.2386 6 13 6C15.7614 6 18 3.76142 18 1" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 18.5V9.5" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20 18.5V9.5" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3 19H23" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 23H21" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg> 
          
          &nbsp;
         </h3>
        </span>  -->
         
      <SidebarToggler   class="d-md-down-none" display="lg" :defaultOpen=true />
     
     <span style="padding-left:5px;">
         <h3><svg width="26" height="24" viewBox="0 0 26 24" fill="none" class="sidebar-custom__img" alt="Collections"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C1 4.13401 4.13401 1 8 1H18C21.866 1 25 4.13401 25 8V14H20V19H6V14H1V8Z" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8 1C8 3.76142 10.2386 6 13 6C15.7614 6 18 3.76142 18 1" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 18.5V9.5" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20 18.5V9.5" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3 19H23" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 23H21" stroke="blue" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg> 
          
          &nbsp;
         </h3>
        </span> 
        {{selected_user_type}}
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none" v-if="selected_user_id !='Admin' && selected_user_type!='Fit_Technician' && selected_user_type !='Quality_Controller' && selected_user_type!='Quality_Executive'">
         
     
      
        <select class="form-control" id="selected_reln_id" name="selected_reln_id" v-model="selected_reln_id" @change="brandselect()"  v-if="selected_user_id =!'Admin'">
          <option :value="brand_list.reln_id" v-for="brand_list in brand_item">{{brand_list.brand_title}}&nbsp;<span v-if="selected_user_type!='Brand_Manager'">({{brand_list.brand_manager}})</span>
          </option>

        </select>
      </b-nav-item> -->
        <b-button variant="primary" class="mr-4" @click="handleExternalLinkClick">SPL PAYMENTS</b-button>

        <b-button variant="primary" class="mr-4" @click="handleExternalLinkClick">SPL GRN</b-button>

        <b-button variant="primary" class="mr-4" @click="handleexternallinkforPO">PO</b-button>

        <b-button variant="primary" class="mr-4" @click="handleExternalLinkClickforASN">ASN</b-button>






      <b-nav-item class="d-md-down-none" v-if="selected_user_type !='Admin' && selected_user_type !='Quality_Controller' && selected_user_type!='Quality_Executive' && selected_user_type!='Graphics_Designer' && selected_user_type !='Planner_Admin' &&selected_user_type !='Planner' && selected_user_type!='ME_USER' ">
         
     
      
        <select class="form-control" id="selected_reln_id" name="selected_reln_id" v-model="selected_reln_id" @change="handleBrandChange" >
          <!-- <option value='selected'>Select Brand</option> -->
          <option :value="brand_list.reln_id" v-for="brand_list in brand_item" :key="brand_list.reln_id">{{brand_list.brand_title}}&nbsp;<span v-if="selected_user_type!='Brand_Manager' && selected_user_type!='Buying_Head' && selected_user_type!='ME_USER' ">({{brand_list.brand_manager}})</span>
          </option>

        </select>
      </b-nav-item>

        <b-nav-item class="d-md-down-none">
          <!-- <b-link class="" to="/collections" > -->
           <img src="../assets/images/fc_logo.png" >
          <!-- </b-link> -->
        </b-nav-item> 

          <!-- <b-nav-item class="d-md-down-none">
            <i class="icon-bell"></i>
            <b-badge pill variant="danger">0</b-badge>
          </b-nav-item> 
         <b-nav-item class="d-md-down-none">
            <i class="icon-list"></i>
          </b-nav-item> --> 
        

        <DefaultHeaderDropdownAccnt/>

      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-none" />
      
    </AppHeader>
    

    <div class="app-body" >

      <!--- Sidebar Menu Created By Prasad-->
        <AppSidebar fixed >
          <sidebarMenu ></sidebarMenu>
        </AppSidebar>  
      <!--- Sidebar Menu Created By Prasad-->

      <!--- Main Container -->
      <main class="main">
         <!-- <Breadcrumb :list="list"/>-->
        <div class="container-fluid">
          <router-view></router-view>          
        </div>
        <div id="overlay" >
          <div class="loader"></div>
          <br/>
          Loading...
      </div>
      </main>
      <!--- Main Container --->

      <!--<AppAside fixed>       
        <DefaultAside/>
      </AppAside>-->
    </div>


    <!--
    <TheFooter>
      
      <div>
       <a href="https://coreui.io">CoreUI</a>
        <span class="ml-1">&copy; 2018 creativeLabs.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
    </TheFooter>
    -->


  </div>
</template>
<script>
import nav1 from '@/_nav'
   import CONSTANTS from '@/utils/constants'
   import navmenubar from '@/_navmenu'
   
   import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
   import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
   const axios = require('axios')
import sidebarMenu from '../components/_sidebarMenu'
   
   export default {
     name: 'DefaultContainer',
     components: {
       AsideToggler,
       AppHeader,
       AppSidebar,
       AppAside,
       TheFooter,
       Breadcrumb,
       DefaultAside,
    DefaultHeaderDropdownAccnt,
       SidebarForm,
       SidebarFooter,
       SidebarToggler,
       SidebarHeader,
       SidebarNav,
       SidebarMinimizer,
    sidebarMenu
     },
     data () {
     
       return {
         email:'',
          nav:'',
          showContent:'notfinance',
          nav_design_list :[],
          vendor_email:'',
          vendor_password:'',
          loginModal: false,
          vendor_name :'',
          vendor_id:'',
          usertype: '',
           // Auto Logout Start
            events:['click','mousemove','mousedown','scroll','keypress','load'],
            // warningTimer:null,
            logoutTimer:null,
            selected: '',
            selected_user_id: 0,
            selected_brand: 0,
            selected_user_type: '',
            brand_item: [],
            selected_brand: '',
            sub_cat_data: [],
            selected_user_id:0,
            selected_reln_id: 0,
            selected_token: '',
            // Auto Logout End
            componentKey:0,
       }
   
   
     },
     created() {  
        if (!localStorage.userData) {
          localStorage.redirectUrl = window.location.href;
          window.location.href = window.location.origin + '/cams_login';
        } 
       this.getuserdetails();
       this.getselecteduserbrand();
       var userData = localStorage.getItem('userData');
       var userInfo = JSON.parse(userData);
       console.log("000000000000000000000000000000000000",userInfo)
       // this.selected_token= userInfo[0].token;
       // axios.defaults.headers.common['x-access-token']  = this.selected_token;
       this.selected_user_type=userInfo[0].user_type;
       this.selected_user_id=userInfo[0].user_id 
       console.log("DDDDDDDDDDDDDDDDDDDDD",userInfo[0].user_type);
       this.selected_reln_id= userInfo[0].reln_id;
       this.selected_user_id=userInfo[0].user_id;
       //this.getDesignSampleList();
 
       this.design_id = this.$route.params.id;
   
       if(typeof(this.design_id) === 'undefined' || this.design_id === null)
       {
         this.showSideMenu='true'
       }
       else{
         this.showSideMenu='false'
       }
       
       // Nav Bar Items
       this.nav=navmenubar.items;
          
     },
     // Auto Logout Start
      // mounted(){
      //   this.events.forEach(function(event){
      //     window.addEventListener(event,this.resetTimer);
      //   },this);
      //   this.setTimer();
      // },
      // destroyed(){
      //    this.events.forEach(function(event){
      //     window.removeEventListener(event,this.resetTimer);
      //   },this);
      //   this.resetTimer();
      // },
      // Auto Logout End
     computed: {
       name () {
         return this.$route.name
       },
       list () {
         return this.$route.matched.filter((route) => route.name || route.meta.label )
       }
     },
     methods: {

        //Code For Select Brand
      getselecteduserbrand: function(value){

        var userData = localStorage.getItem('userData');
        // localStorage.setItem('userData', JSON.stringify(userData))
       var userInfo = JSON.parse(userData);
       // console.log("777777777777777777777777",userData[token])
      // axios.defaults.headers.common['x-access-token']  = this.selected_token;
      
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Connection']= 'close';
        
        // axios.defaults.headers.common['Origin']='http://localhost:8080';

         this.isBusy = true;  
         const Obj ={
           user_id: userInfo[0].user_id
         }  
        axios.post(`${CONSTANTS.API_URL}/getAllocateddBrandList`,Obj)
        .then(response => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === 'Successful') {
            this.brand_item  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            // if(this.result.returnvalue==='No token provided..'){
            //   localStorage.setItem('userData', '');
            // this.$router.push('/login').catch(()=>{});
            // }
            // else{
               this.brand_item =[];
               this.totalRows=0;
               this.isBusy = !this.isBusy;
             //}
          }
          


        })
        .catch(e => {
          this.errors.push(e)
        })
      },
      //Code Ends For Select Brand
      forceRerender() {
      this.componentKey += 1;
    },
       handleBrandChange() {
        let obj = this.brand_item.find(o => o.reln_id === this.selected_reln_id);
        console.log("222222222222222222222222222------------------->",obj);
        localStorage.setItem('selectedBrandId',JSON.stringify({target:{value:obj.brand_id+"+"+obj.brand_title}}));
        document.getElementById("overlay").style.display = "block";
        const Obj ={
          user_id: this.selected_user_id,
          reln_id: this.selected_reln_id
        } 
        
        axios.post(`${CONSTANTS.API_URL}/getAssignedSubCategory`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          // console.log('getAssignedSubCategory response------------>',response)
          if(response.data && response.data.returnvalue && response.data.returnvalue.length>0){
            let userData = JSON.stringify(response.data.returnvalue)
            localStorage.setItem('userData', userData)
            console.log("this.$router",this.$route.fullPath.split('/')[1])
            let presentRoute = this.$route.fullPath.split('/')[1]
            let tempDashboardNameList = ['dashboard_quality','dashboard_designhead','dashboard_buyer','dashboard_quality','fittech_list','dashboard_designer','dashboard_brand_manager','dashboard_buyingHead']
            let isRoutePresent = tempDashboardNameList.includes(presentRoute)
            console.log("isRoutePresent",isRoutePresent)
            if(isRoutePresent == true)
            {
              this.forceRerender()
            }
            else{

              if(this.selected_user_type=='Quality_Head' ){
              this.$router.push('/dashboard_quality')
              .catch((error) => {console.log('rerouting error msg------>',error)});
              }
              else if(this.selected_user_type=='Design_Head'){
                this.$router.push('/dashboard_designhead')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }
              else if(this.selected_user_type=='Buyer'){
                this.$router.push('/dashboard_buyer')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }
                else if(this.selected_user_type=='Junior_Buyer'){
                this.$router.push('/dashboard_buyer')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }
              else if(this.selected_user_type=='Quality_Controller' ){
                this.$router.push('/dashboard_quality')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }
              else if(this.selected_user_type=='Fit_Technician'){
                this.$router.push('/fittech_list')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }
              else if(this.selected_user_type=='Brand_Designer'){
                this.$router.push('/dashboard_designer')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }
              else if(this.selected_user_type=='Brand_Manager'){
                this.$router.push('/dashboard_brand_manager')
                .catch((error) => {console.log('rerouting error msg------>',error)});
              }else{
                console.log('error in user type matching and rerouting on brand change!')
              }

            }
            

            
          }else{
            console.log('invalid getAssignedSubCategory result!')
          } 
        })
        .catch(err=>{
          document.getElementById("overlay").style.display = "none";
          console.log('handleBrandChange error----------->',err)
        })
      },

        /****** Function to Vendor Login ********/
      brandselect(){
        // console.log("NNNNNNNNNNNNNNNNNNNNNNNNNNNNN",value)
        document.getElementById("overlay").style.display = "block";
         var userData=[];
          this.isBusy = true;  
           const Obj ={
             user_id: this.selected_user_id,
             reln_id: this.selected_reln_id
           } 
          axios.post(`${CONSTANTS.API_URL}/getAssignedSubCategory`,Obj)
          .then(response => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            console.log('response.data--------------------->',response.data)
            console.log('response.data.returnvalue--------------------->',response.data.returnvalue)
            if (this.result.returnmsg === 'Successful') {
              // localStorage.setItem('userData', '');
              // this.sub_cat_data  = this.result.returnvalue;
              // var userData =this.result.returnvalue;
              localStorage.setItem('userData', JSON.stringify(this.result.returnvalue))   
              // localStorage.setItem('userData', JSON.stringify(userData))

              // var temp_userData=localStorage.getItem('userData', JSON.stringify(userData))
              // var userInfo = JSON.parse(temp_userData)
              // // temp_userData= JSON.stringify(temp_userData)
              // userInfo[0].subcat_assign=[];
              // userInfo[0].brand_assign=[];
              // userInfo[0].subcat_assign.push(this.result.returnvalue[0].subcat_assign);
              // userInfo[0].brand_assign.push(this.result.returnvalue[0].brand_assign);
              // // userInfo[1].push(Obj);
              // localStorage.setItem('userData', JSON.stringify(userInfo))
              
                // && this.$router.path=='dashboard_quality'
               if(this.selected_user_type=='Quality_Head' ){
                    this.$router.push('/dashboard_quality').catch((error) => {this.redirect()});
                  }
                   // && this.$route.name!='dashboard_designhead'
                  else if(this.selected_user_type=='Design_Head'){
                    this.$router.push('/dashboard_designhead').catch((error) => {this.redirect()});
                  }
                   // && this.$route.name=='dashboard_buyer'
                  else if(this.selected_user_type=='Buyer'){
                    this.$router.push('/dashboard_buyer').catch((error) => {this.redirect()});
                  }
                   else if(this.selected_user_type=='Junior_Buyer'){
                    this.$router.push('/dashboard_buyer').catch((error) => {this.redirect()});
                  }
                   // && this.$route.name=='dashboard_quality'
                  else if(this.selected_user_type=='Quality_Controller' ){
                    this.$router.push('/dashboard_quality').catch((error) => {this.redirect()});
                  }
                   // && this.$route.name=='fittech_list'
                  else if(this.selected_user_type=='Fit_Technician'){
                    this.$router.push('/fittech_list').catch((error) => {this.redirect()});
                  }
                    // && this.$route.name=='dashboard_designer'
                  else if(this.selected_user_type=='Brand_Designer'){
                    this.$router.push('/dashboard_designer').catch((error) => {this.redirect()});
                  }
                   // && this.$route.name=='dashboard_brand_manager'
                  else if(this.selected_user_type=='Brand_Manager'){
                    
                    this.$router.push('/dashboard_brand_manager').catch((error) => {this.redirect()});; 
                       
                  }
              // this.getuserdetails();
              this.totalRows = this.result.returnvalue.length;
              this.isBusy = !this.isBusy;
              
            }else {
             this.sub_cat_data =[];
             this.totalRows=0;
               this.isBusy = !this.isBusy;
            }

          })
          .catch(e => {
            document.getElementById("overlay").style.display = "none";
            // this.errors.push(e)
            console.log('error---------------->',e)
          })
             
        //     }

        // })
      },

      redirect: function(){
     
        // if(this.selected_user_type=='Fit_Technician' || this.selected_user_type=='Design_Head' || this.selected_user_type=='Quality_Controller'){
        //   this.$router.replace('/updateProfile').catch((error) => {});
          
        // }
        // else{
        //   this.$router.replace('/brands').catch((error) => {});
        // }

         if(this.selected_user_type=='Quality_Head' ){
              this.$router.push('/dashboard_quality').catch((error) => {this.redirect()});
            }
              // && this.$route.name!='dashboard_designhead'
            else if(this.selected_user_type=='Design_Head'){
              this.$router.push('/dashboard_designhead').catch((error) => {this.redirect()});
            }
              // && this.$route.name=='dashboard_buyer'
            else if(this.selected_user_type=='Buyer'){
              this.$router.push('/dashboard_buyer').catch((error) => {this.redirect()});
            }
              else if(this.selected_user_type=='Junior_Buyer'){
              this.$router.push('/dashboard_buyer').catch((error) => {this.redirect()});
            }
              // && this.$route.name=='dashboard_quality'
            else if(this.selected_user_type=='Quality_Controller' ){
              this.$router.push('/dashboard_quality').catch((error) => {this.redirect()});
            }
              // && this.$route.name=='fittech_list'
            else if(this.selected_user_type=='Fit_Technician'){
              this.$router.push('/fittech_list').catch((error) => {this.redirect()});
            }
              // && this.$route.name=='dashboard_designer'
            else if(this.selected_user_type=='Brand_Designer'){
              this.$router.push('/dashboard_designer').catch((error) => {this.redirect()});
            }
              // && this.$route.name=='dashboard_brand_manager'
            else if(this.selected_user_type=='Brand_Manager'){
              
              this.$router.push('/dashboard_brand_manager').catch((error) => {this.redirect()});; 
                  
            }
            else{
          this.$router.replace('/brands').catch((error) => {});
        }
  
        // this.getuserdetails();
        // this.$router.push('/dashboard_brand_manager').catch((error) => {});
        // alert("mm")
        // this.$router.replace('/dashboard_brand_manager')
        // location.reload();
        // window.history.go(0)
        // this.$router.go(-1)
       // this.$router.go(0);
      },

      //Code For Select Brand

        getuserdetails: function() {
          
         var userData = localStorage.getItem('userData')

         if (userData) {

           var userInfo = JSON.parse(userData)

           this.vendor_id = userInfo.vendor_id; 

         

           this.design_id = userInfo[0].design_id; 
           this.vendor_name = userInfo[0].vendor_name;
           this.email = userInfo[0].email_id;
      
           this.adminuser=userInfo[0].full_name;

           this.usertype=userInfo[0].user_type;
          
          
         } else {
           //this.$router.push('login')
         }
        },

         // Auto Logout Start
          setTimer:function(){
           // this.warningTimer=setTimeout(this.warningMessage,5*1000);//14 min
            this.logoutTimer=setTimeout(this.logoutUser,60*60*1000);//10min
          },
          warningMessage:function(){
            alert('are you there!');
          },
           logoutUser: function() {
            localStorage.setItem('userData', '')
            localStorage.setItem('filters','')
            localStorage.removeItem('selected_brand_id')
           
            this.$router.push('/cams_login').catch(()=>{});
             // window.location.href ="/login";
             clearTimeout(this.logoutTimer);
            //document.getElementById('login-form').submit();
          },
          resetTimer:function(){
            // clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);
            this.setTimer();
          },

          // Auto Logout End




      /****** Function to Vendor Login ********/
      vendorlogin (scope) {
      this.$validator.validateAll(scope).then((result) => {
        var userData = localStorage.getItem('userData');
       var userInfo = JSON.parse(userData);
          if (result) {

            const loginObj = {
                  vendoremailid: this.vendor_email,
                  vendorpassword : this.vendor_password
            }


            if (this.quantity !== '') {
              axios.post(`${CONSTANTS.API_URL}/validatevendorslogin`,loginObj)
              .then(response => {
                 
                  
                  if(response.data.returnmsg == 'successful') {
                    this.selected_user_id=userData[0].user_id;
                    // this.selected_brand= userData[0].brand_id;

                  var userData =response.data.returnvalue;
                  console.log(userData);

                  localStorage.setItem('userData', JSON.stringify(userData))
                 
                      //this.$router.push('/')
                     window.location.href ="/";
                  } else {
                    if (result.body.returnmsg === 'NoUserExists') {
                  
                      this.showAlert=true
                      
                    }
                  }
                })
              }
          }

      })
      },


    // logout: function() {
    //   localStorage.setItem('userData', '')
      
    //  window.location.href ="/";
    // }
       handleExternalLinkClick: async function () {
         try {
           let frslink = localStorage.getItem('frslink') ? localStorage.getItem('frslink') : '';
          //  if (frslink) {
             window.open('https://misreports.brainbees.com/login', "_blank");
          //  } else {
          //    console.error("Final URL not found in the response");
          //    alert("Unable to generate link. Please try again.");
          //  }
         } catch (error) {
           console.error("Error while fetching external link:", error);
           alert("Authentication failed. Please check credentials.");
         }
       },

       handleexternallinkforPO: async function () {
         try {
           let polink = localStorage.getItem('polink') ? localStorage.getItem('polink') : '';
          //  if (polink) {
             window.open('https://in-procure.brainbees.com/#/login', "_blank");
          //  } else {
          //    console.error("Final URL not found in the response");
          //    alert("Unable to generate link. Please try again.");
          //  }
         } catch (error) {
           console.error("Error while fetching external link:", error);
           alert("Authentication failed. Please try again.");
         }
       },
       handleExternalLinkClickforASN(){
        try {
            window.open('https://in-supplier.brainbees.com/#/login', "_blank");
        } catch (error) {
          console.error("Error while fetching external link:", error);
          alert('Something went wrong. Please try again.');
        }
       }


     }
  };
</script>
<style>
body{
  
  font-family:Nunito Sans,sans-serif !important;
}
   .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before{
   float: none!important;
   }
   .breadcrumb{
   margin-bottom: 0px;
   }
   .app-header .navbar-brand {
   left: 32%!important;
   }
   .app-header .nav-item .nav-link{
   padding-right: 30px;
   }
.sidebar{
    background:  cornflowerblue!important;
  }
  .sidebar .nav-link .nav-icon{
    color: #fff!important;
  }
  .sidebar .nav-link:hover {
    background: #ECEFF1!important;
    color: #333!important;
  }
  .sidebar .nav-link.active{
    background: #f09642!important;
  }
  .table thead, .table thead tr {
    background: #ECEFF1 !important;
    word-wrap: break-word;
}
 .table thead, .table thead tr:hover {
    background: #ECEFF1 !important;
}
.table th, .table td {
    padding: .5rem!important;
    vertical-align: top!important;
}
.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}
.card{
      word-wrap: break-word!important;
}
.table-striped tbody tr:nth-of-type(odd) {
     background-color: #fff !important;
}
.sidebar .nav-dropdown{
    background: #17a2b8!important;
}
.ps:hover>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
    background-color: #17a2b8!important;
}
.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y {
   background-color: #f09642!important;
   display: block !important;
   }
   .ps>.ps__scrollbar-y-rail {
   display: block !important;
   }
   .table.b-table > thead > tr > th[aria-sort][aria-sort="ascending"]::after, .table.b-table > tfoot > tr > th[aria-sort][aria-sort="ascending"]::after, 
   .table.b-table > thead > tr > th[aria-sort][aria-sort="descending"]::after, .table.b-table > tfoot > tr > th[aria-sort][aria-sort="descending"]::after,
   .table.b-table > thead > tr > th[aria-sort]::after, .table.b-table > tfoot > tr > th[aria-sort]::after{
   font-size: 25px;
   padding-bottom: 0 !important;
   }
   .col-form-label{
   font-weight: bold;
   }
   .sidebar .nav-dropdown-toggle::after{
   -webkit-transform: rotate(-50deg) !important;
   }
   .sidebar .nav-dropdown.open > .nav-dropdown-toggle::before{
   -webkit-transform: rotate(45deg)!important;
   }
   .table tr th {
   color: #333 !important;
   }
.main .container-fluid {
    padding: 0 0px!important;
}
.wing{
  width: 20%
}

 .sidebar-lg-show.sidebar-fixed .main, html:not([dir="rtl"]) .sidebar-lg-show.sidebar-fixed .app-footer, html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .main, html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .app-footer {
    margin-left: 80px !important;
}

/*html:not([dir="rtl"]) .sidebar-lg-show.sidebar-fixed .main, html:not([dir="rtl"]) .sidebar-lg-show.sidebar-fixed .app-footer, html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .main, html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .app-footer {
    margin-left: 30px !important;
}*/

/*
.card {
   margin-bottom: 0px!important;

}*/


  

   .design-container-details {
  height: 100%;
  z-index: 15;
}

.design-container-details__sidebar-item {
  height: 56px;
  padding: 18px 30px;
  cursor: pointer;
  align-items: center;
}

.design-list__item {
  height: 70px;
  padding: 12px 20px;
  padding-right: 6px;
  border-bottom: 1px solid #d4d4d4;
  cursor: pointer;
}

.design-list__item--active {
  background-color: #d4efff;
  
}

.design-list__title {
  margin-bottom: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
}

.design-container-details__main {
  flex-grow: 1;
}

.brand-card{
  border-radius:0px !important; 
}

.head_menu_portal{
  width: 80px;height: 55px;background-color: cornflowerblue !important;color: white;text-align: center;font-weight: bold;border-bottom: 1px solid gainsboro;padding-top:5px;
}

#overlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
} 
.swal2-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
}
.main{
  margin-left:0px !important;
}
@media (max-width: 990px)
{
.sidebar-lg-show.sidebar-fixed .main, html:not([dir="rtl"]) .sidebar-lg-show.sidebar-fixed .app-footer, html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .main, html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .app-footer {
    margin-left: 0px !important;
}
}
@media (max-width: 990px)
{
.sidebar-show .main::before, .aside-menu-show .main::before {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1018;
    width: 100%;
    height: 100%;
    content: "";
    background: rgba(0, 0, 0, 0.7);
    animation: opacity 0.25s;
}
}
</style>
